
import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, Input, Button, Row, Col, DatePicker, Select } from 'antd';
import { statusIndexToText } from '../statusConfig';
import { formItemLayout } from '../../../util/formItemLayoutConfig';
import './searchForm.less';

const { RangePicker } = DatePicker;
const { Option } = Select;

export const SearchForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const onFinish = () => {
    props.searchFn();
  };
  const onExport = () => {
    props.exportFn();
  };

  useImperativeHandle(ref, () => ({ form }));

  return (
    <div className='search-form-container'>
      <Form form={form} name="order-form" {...formItemLayout} onFinish={onFinish}>
        <Row>
          <Col span={8}>
            <Form.Item name="order_no" label='订单关键词：' className='search-form-label'>
              <Input placeholder="商品名称/订单号" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="consignee_name" label='收货人姓名：' className='search-form-label' >
              <Input placeholder="" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="supplier_name" label='卖家公司名称：' className='search-form-label'>
              <Input placeholder="" />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="order_status" label='订单状态：' className='search-form-label'>
              <Select placeholder='全部'>{Reflect.ownKeys(statusIndexToText).map(item => <Option key={item}>{statusIndexToText[item]}</Option>)}</Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="dateRange" label='下单日期：' className='search-form-label'>
              <RangePicker format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="container_no" label='柜号：' className='search-form-label'>
              <Input placeholder="" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8} offset={16}>
            <Form.Item wrapperCol={{ span: 24 }}>
              <div className='search-form-btn-container'>
                <Button type='primary' className='search-form-btn' htmlType="submit"> 查询 </Button>
                <Button type='default' style={{marginLeft: 20}} className='search-form-btn' onClick={onExport}> 数据导出 </Button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div >
  );
});
